// Français pour <Tx> — les marques qui disent ce que l’on est en train de lire. Apostrophe
// typographique ’ partout. « Cancel » vient du vocabulaire partagé (i18n/common.fr.ts) et n’est
// délibérément pas réenregistré ici.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Original: {language} — click to read it': 'Original : {language} — cliquez pour le lire',
  'Original: {language}. The {target} translation has not landed yet.': 'Original : {language}. La traduction en {target} n’est pas encore arrivée.',
  'Written in {language}{assumed} — click to read it in {target}': 'Rédigé en {language}{assumed} — cliquez pour le lire en {target}',
  ' (assumed)': ' (présumé)',
  'Translation corrected by an operator': 'Traduction corrigée par un opérateur',
  'Machine translation ({model}) — a proposal about wording, not the record': 'Traduction automatique ({model}) — une proposition de formulation, pas l’enregistrement',
  'Translating…': 'Traduction en cours…',
  'The source has changed since this translation was written — review it': 'La source a changé depuis cette traduction — à revoir',
  'The source or the terminology has changed — a fresh translation is on its way': 'La source ou la terminologie a changé — une nouvelle traduction arrive',
  'A superseded version — its translation is kept as it was and is never refreshed': 'Une version remplacée — sa traduction est conservée telle quelle et n’est jamais rafraîchie',
  'Terminology not carried through: {terms}': 'Terminologie non reprise : {terms}',
  'Reverting discards your wording and asks the model again. Continue?': 'Le rétablissement écarte votre formulation et interroge à nouveau le modèle. Continuer ?',
  'Save the translation': 'Enregistrer la traduction',
  'Correct this translation': 'Corriger cette traduction',
  'Revert to the machine translation': 'Rétablir la traduction automatique',
  'Translate this again': 'Traduire à nouveau',
  'Content language': 'Langue du contenu',
  'The language engagement content is shown in. The record itself never changes.': 'La langue dans laquelle le contenu du mandat est affiché. L’enregistrement lui-même ne change jamais.',
  'Content: as written': 'Contenu : tel que rédigé',
  'Content: follow the console': 'Contenu : suivre la console',
  'Content: {language}': 'Contenu : {language}',
  'Show the original language on every item': 'Afficher la langue d’origine sur chaque élément',
  'This does not read as {expected} — it looks like {detected}. Shown anyway; the record is one click away.':
    'Ce texte ne se lit pas comme du {expected} – il ressemble à du {detected}. Affiché malgré tout ; le contenu d’origine est à un clic.',

}, 'Tx');
